<template>
  <div class="point-picker">
    <van-cell
      :title="selected ? selected.name : '選擇地點（選填）'"
      is-link
      :value="selected ? categoryLabel(selected.category) : ''"
      @click="open = true"
    />
    <van-popup v-model="open" position="bottom" round :style="{ maxHeight: '75%' }">
      <div class="picker-head">
        <van-search v-model="keyword" placeholder="搜尋這趟 Trip 已收藏的地點" />
      </div>
      <div class="picker-list">
        <van-cell v-if="value" title="不關聯地點" icon="close" clickable @click="choose(null)" />
        <van-cell
          v-for="p in filtered" :key="p.id"
          :title="p.name" :label="p.address"
          clickable @click="choose(p)"
        >
          <template #right-icon>
            <span class="tag-chip">{{ categoryLabel(p.category) }}</span>
          </template>
        </van-cell>
        <div v-if="!filtered.length" class="empty-state"><span class="emoji">📍</span>沒有符合的地點</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PLACE_CATEGORY_LABELS } from '@/utils/mockPlaces'

export default {
  name: 'PointPicker',
  props: {
    value: { type: String, default: null },
    tripId: { type: String, required: true }
  },
  data () {
    return { open: false, keyword: '' }
  },
  computed: {
    ...mapGetters({ pointsByTrip: 'points/byTrip' }),
    points () {
      return this.pointsByTrip(this.tripId)
    },
    filtered () {
      const kw = this.keyword.trim().toLowerCase()
      if (!kw) return this.points
      return this.points.filter(p => p.name.toLowerCase().includes(kw))
    },
    selected () {
      return this.points.find(p => p.id === this.value) || null
    }
  },
  methods: {
    categoryLabel (c) {
      return PLACE_CATEGORY_LABELS[c] || c
    },
    choose (p) {
      this.$emit('input', p ? p.id : null)
      this.open = false
    }
  }
}
</script>

<style scoped>
.picker-head {
  border-bottom: 1px solid var(--color-border);
}
.picker-list {
  max-height: 55vh;
  overflow-y: auto;
  padding-bottom: 12px;
}
</style>
